export const en = {
  '2': '”',
  detectingSocialSignals: 'Detecting Social Signals…',
  assessingJurisdictionRisk: 'Assessing Jurisdiction Risk…',
  scanningForAdverseMedia: 'Scanning for Adverse Media…',
  checkingPepExposure: 'Checking PEP Exposure…',
  searchingGlobalWatchlists: 'Searching Global Watchlists…',
  agentDrivenIntelligence: 'Agent-Driven Intelligence',
  alwaysWatching: 'Always Watching',
  behindTheScenesMultipleRavenAgentsOperateSimultaneouslyMonitoring:
    'Behind the scenes, multiple Raven agents operate simultaneously—monitoring social signals, global watchlists, jurisdiction risk, PEP exposure, and adverse media to detect risk signals and produce a unified compliance report.',
  scrollToExplore: 'Scroll to explore',
  readyToGetStartedWithRaven: 'Ready to Get Started with Raven?',
  seeHowRavenCanStreamlineYourWorkflowBookA:
    'See how Raven can streamline your workflow. Book a demo or launch your workspace today.',
  bookADemo: 'Book A Demo',
  openMenu: 'Open menu',
  closeMenu: 'Close menu',
  launchRaven: 'Launch Raven',
  buildAMonitoringDashboard: 'Build a monitoring dashboard',
  buildARealTimeDashboardForYourComplianceTeam:
    'Build a real-time dashboard for your compliance team — monitor risk scores, client status, and recent screenings, all read-only and audit-ready.',
  form: 'Form',
  buildAClientIntakeFlow: 'Build a client intake flow',
  buildFrontEndFormsThatSubmitNewClientsTo:
    'Build front-end forms that submit new clients to Raven, with automatic validation, error handling, and secure API calls.',
  workspace: 'Workspace',
  buildAReviewerWorkspace: 'Build a reviewer workspace',
  aFullWorkspaceForComplianceReviewersSeeEvidenceAdd:
    'A full workspace for compliance reviewers: see evidence, add notes, change client status, and keep a complete audit trail.',
  launch: 'Launch',
  launchYourDueDiligencePlatform: 'Launch your due diligence platform',
  theFinalEndToEndFrontEndFromSubmitting:
    'The final, end-to-end front-end — from submitting client information to report generation, ready to deploy.',
  ravenApiWorkflows: 'Raven API workflows',
  buildRavenWorkflowsYourself: 'Build Raven workflows yourself',
  stepByStepGuidedWorkflowsStartWithATemplate:
    'Step-by-step guided workflows — start with a template, end with a production-ready compliance app.',
  ourSolution: 'Our Solution',
  whoIsRavenFor: 'Who is Raven For?',
  aboutUs: 'About Us',
  customerReviews: 'Customer Reviews',
  smartDueDiligencePlatformForModernOrganizationsAutomatedIntelligent:
    'Smart Due Diligence platform for modern organizations. Automated, Intelligent, Traceable.',
  parisFrance: 'Paris, France',
  solutions: 'Solutions',
  quickLinks: 'Quick Links',
  '2026RavenAllRightsReserved': '© 2026 Raven, all rights reserved.',
  smartDueDiligencePlatform: 'Smart Due Diligence Platform',
  agenticDueDiligence: 'Agentic Due Diligence',
  automatedIntelligentTraceable: 'Automated.  Intelligent.  Traceable.',
  ravenEmpowersOrganizationsTo: 'Raven empowers organizations to',
  performKycAndKybFasterAndSmarter: 'perform KYC and KYB faster and smarter',
  launchPlatform: 'Launch Platform',
  startWithApi: 'Start with API',
  intelligentIdentityVerification: 'Intelligent Identity Verification',
  universalDocumentProcessing: 'Universal Document Processing',
  automatedDataCollection: 'Automated Data Collection',
  riskSignalDetectionScoring: 'Risk Signal Detection & Scoring',
  complianceReportGeneration: 'Compliance Report Generation',
  continuousRiskMonitoring: 'Continuous Risk Monitoring',
  knowYourIndividualClient: 'Know Your Individual Client',
  knowYourBusinessClient: 'Know Your Business Client',
  enterpriseGradeIntelligence: 'Enterprise-Grade Intelligence',
  aUnifiedPlatformBuiltForPrecisionControlAndComplete:
    'A unified platform built for precision, control, and complete operational visibility.',
  smartKycKyb: 'Smart KYC & KYB',
  automatedEndToEndDueDiligenceForIndividualsAnd:
    'Automated, end-to-end due diligence for individuals and businesses.',
  seeTheRiskScoringAndReportGenerationFlow: 'See the Risk scoring and Report Generation Flow',
  automatedSearchAutoFillWorkflowsAndFastRiskScoring:
    'Automated search, auto-fill workflows and fast risk scoring to help assess individual and business clients in minutes.',
  linkedin: 'LinkedIn',
  instagram: 'Instagram',
  yourComplianceReportIsReady: 'Your Compliance Report Is Ready',
  profileDecision: 'Profile & Decision',
  am: 'AM',
  alexMorgan: 'Alex Morgan',
  canadian: 'Canadian',
  netWorth: 'Net Worth:',
  softwareEngineer: 'Software engineer',
  riskSummary: 'Risk Summary',
  basedOnTheConductedKycChecksTheClientPresents:
    'Based on the conducted KYC checks, the client presents a medium to high risk profile. Screening results indicate potential exposure to politically exposed persons (PEP) and limited adverse media mentions, primarily related to business affiliations rather than direct personal involvement. The client operates within a jurisdiction that carries moderate regulatory risk.',
  globalWatchlistMatch: 'Global Watchlist Match',
  pepDetected: 'PEP Detected',
  adverseMediaFound: 'Adverse Media Found',
  '1HighRiskStakeholder': '1 High-Risk Stakeholder',
  '3MediumRiskStakeholders': '3 Medium-Risk Stakeholders',
  relativeContributionOfEachFactorToTheClientS:
    "Relative contribution of each factor to the client's final risk level",
  occupationalRisk: 'Occupational Risk',
  politicalExposure: 'Political Exposure',
  adverseMedia: 'Adverse Media',
  sanctionsExposure: 'Sanctions Exposure',
  jurisdictionRisk: 'Jurisdiction Risk',
  seeWhyTheBusinessHasBeenAssignedA: 'See why the business has been assigned a',
  riskLevel: 'Risk level.',
  whyRiskLevelIsMedium: 'Why Risk Level is Medium?',
  riskIndicatorsArePresentButIndirectAndBusinessRelated:
    'Risk indicators are present but indirect and business-related',
  noCriticalSanctionsOrAdverseMediaFindings: 'No critical sanctions or adverse media findings',
  jurisdictionAndOccupationalRisksAreModerate: 'Jurisdiction and occupational risks are moderate',
  overallExposureExceedsLowRiskThresholds: 'Overall exposure exceeds Low Risk thresholds',
  detectedSignals: 'Detected Signals',
  riskSignals: 'Risk Signals',
  globalWatchLists: 'Global Watch Lists',
  linkedToSanctionedCountriesOrEntities: 'Linked to Sanctioned Countries or Entities',
  '2IssuesDetected': '2 issues detected',
  moreDetails: 'more details',
  pepScreening: 'PEP Screening',
  indirectRelationshipWithPoliticallyExposedPersons:
    'Indirect relationship with politically exposed persons',
  '3IssuesDetected': '3 issues detected',
  noIssuesDetected: 'No issues detected',
  '0IssuesDetected': '0 issues detected',
  onePriorRegulatoryIncident: 'One prior regulatory incident',
  '1IssueDetected': '1 issue detected',
  socialSignals: 'Social Signals',
  multipleRiskIndicatorsIdentifiedAcrossSocialMediaProfiles:
    'Multiple Risk Indicators Identified Across Social Media Profiles',
  corporateAssociationVerifiedThroughLinkedinProfile:
    'Corporate Association Verified Through LinkedIn Profile',
  linkedinClientAccount: 'LinkedIn (client account)',
  frequentDisplayOfLuxuryAssetsInconsistentWithDeclaredProfile:
    'Frequent Display of Luxury Assets Inconsistent with Declared Profile',
  instagramClientAccount: 'Instagram (client account)',
  repeatedInteractionWithPoliticallySensitiveContent:
    'Repeated Interaction with Politically Sensitive Content',
  xClientAccount: 'X (client account)',
  complianceReimaginedForHumans: 'Compliance, Reimagined for Humans',
  ravenExistsToGiveComplianceTeamsTheirTimeBack:
    'Raven exists to give compliance teams their time back — and their clarity forward.',
  weCombine: 'We combine',
  deepExpertiseWithAHumanFirstApproach: 'deep expertise with a human-first approach',
  toTurnComplianceFromABottleneckIntoASeamless:
    'to turn compliance from a bottleneck into a seamless part of your operations.',
  everyLayerOfOurPlatformIsBuiltTo: 'Every layer of our platform is built to',
  reduceFriction: 'reduce friction',
  increaseTransparency: 'increase transparency',
  and: ', and',
  scaleWithYou: 'scale with you',
  withoutCompromisingOnSecurityOrPrecision: '— without compromising on security or precision.',
  ourMissions: 'Our Missions',
  teamCollaborationOperations: 'Team Collaboration & Operations',
  toolsToStreamlineTeamworkTaskManagementAndClientOversight:
    'Tools to streamline teamwork, task management, and client oversight across your organization.',
  rolePermissionManagement: 'Role & Permission Management',
  unifiedMonitoringDashboard: 'Unified Monitoring Dashboard',
  structuredClientDataHistory: 'Structured Client Data & History',
  runInstantClientScreenings: 'Run Instant Client Screenings',
  seeRiskEvidenceNeverAFakeApprovedLabel: 'See risk evidence — never a fake "approved" label',
  buildASimpleSearchBoxEnterAClientName:
    'Build a simple search box. Enter a client name, get back sanctions, PEPs, or adverse media — clearly presented as evidence to review, never as a final decision.',
  watchClientProgressLive: 'Watch Client Progress Live',
  knowExactlyWhenAScreeningFinishesOrAReport:
    'Know exactly when a screening finishes or a report is ready',
  yourDashboardUpdatesInRealTimeAsWorkflowsComplete:
    'Your dashboard updates in real time as workflows complete. See status changes, warnings, or errors as they happen — no guessing, no constant refreshing.',
  shareTheRightReportWithTheRightPerson: 'Share the Right Report with the Right Person',
  customerViewVsInternalView: 'Customer view vs. internal view',
  generateReportsTailoredToWhoSReadingClientsSee:
    "Generate reports tailored to who's reading. Clients see only what they should. Your compliance team sees full notes, audit trails, and restricted comments. No more accidental oversharing.",
  updateClientInfoOnePieceAtATime: 'Update Client Info One Piece at a Time',
  smallChangesSafeSavesCleanerReviews: 'Small changes, safe saves, cleaner reviews',
  insteadOfSavingAnEntireProfileAtOnceUpdate:
    'Instead of saving an entire profile at once, update only what changed — a new address, a risk note, or a document. Fewer errors, automatic saving, and a much clearer review screen.',
  createCompleteClientProfiles: 'Create Complete Client Profiles',
  turnAScreeningIntoAPermanentClientFile: 'Turn a screening into a permanent client file',
  oneClickTransformsAnySearchIntoAFullClient:
    'One click transforms any search into a full client profile. Save notes, upload documents, and come back weeks later — everything is organized and audit‑ready.',
  keepHumanDecisionsInControl: 'Keep Human Decisions in Control',
  ravenRecommendsYourTeamDecides: 'Raven recommends. Your team decides',
  buildAReviewScreenThatClearlyShowsTheEvidence:
    "Build a review screen that clearly shows: the evidence, Raven's suggestion, and a final box for your reviewer's decision — including a required reason. The AI helps, but the human stays accountable.",
  buildDueDiligenceYourWay: 'Build due diligence your way',
  buildCustomDashboardsManageClientProfilesGenerateReportsThrough:
    'Build custom dashboards, manage client profiles, generate reports through Raven agents, and automate screening workflows — all with an API designed for regulated industries. Integrate into your existing platform or build from scratch.',
  readyToStartWithRavenApi: 'Ready to start with Raven API?',
  getAccessToYourApiKeyAndAchieveWhat: "Get access to your API key and achieve what's promised",
  getYourApiKey: 'Get your API key',
  riskScoreDecisionSummary: 'Risk Score & Decision Summary',
  riskSignalsScreeningInsights: 'Risk Signals & Screening Insights',
  socialMediaIntelligence: 'Social & Media Intelligence',
  stakeholderRiskAnalysisKyb: 'Stakeholder Risk Analysis (KYB)',
  advancedComplianceInsights: 'Advanced Compliance Insights',
  comprehensiveDecisionReadyInsightsEmbeddedInEveryGeneratedReport:
    'Comprehensive, decision-ready insights embedded in every generated report.',
  riskScore: 'Risk Score',
  clearRiskClassificationLowMediumHighWithAConcise:
    'Clear risk classification (Low, Medium, High) with a concise summary to support fast decision-making.',
  '': '“',
  whatOurCustomersSay: 'What Our Customers Say',
  realFeedbackFromPeopleWhoHaveExperiencedTheRaven:
    'Real feedback from people who have experienced the Raven',
  whoIsRavenFor2: 'Who is Raven for?',
  builtForTeamsThatVerifyIdentities: 'Built for Teams that Verify Identities',
  forOrganizationsThatNeedReliableKycAndKyb: 'For organizations that need reliable KYC and KYB',
  ravenIsDesignedForOrganizationsThatNeedToVerify:
    'Raven is designed for organizations that need to verify their clients through KYC and KYB processes, especially when',
  handlingSensitiveIdentityInformation: 'handling sensitive identity information',
  banksNeobanksFintechCompaniesGovernmentInstitutions:
    'banks, neobanks, fintech companies, government institutions',
  andAnyOrganizationResponsibleForValidatingClientIdentities:
    ', and any organization responsible for validating client identities.',
  thePlatformIsBuiltSo: 'The platform is built so',
  complianceAndVerificationOfficers: 'compliance and verification officers',
  canReviewClientsQuicklyAndEfficientlyWhile: 'can review clients quickly and efficiently, while',
  managersAndDecisionMakers: 'managers and decision-makers',
  canEasilyMonitorTheEntireProcessAndMaintainFull:
    'can easily monitor the entire process and maintain full oversight.',
  exploreSolution: 'Explore Solution',
  getInTouch: 'Get in Touch',
  readyToTransformYourComplianceOperationsReachOutTo:
    'Ready to transform your compliance operations? Reach out to our team.',
  fullName: 'Full Name',
  johnDone: 'John Done',
  organizationNameOptional: 'Organization Name (Optional)',
  acmeCorporation: 'Acme Corporation',
  message: 'Message',
  tellUsHowCanWeHelpYou: 'Tell us how can we help you...',
  submit: 'Submit',
} as const;
export const fa: Record<keyof typeof en, string> = {
  '2': '»',
  detectingSocialSignals: 'در حال بررسی شبکه‌های اجتماعی…',
  assessingJurisdictionRisk: 'در حال ارزیابی ریسک کشور…',
  scanningForAdverseMedia: 'در حال جست‌وجوی اخبار منفی…',
  checkingPepExposure: 'در حال بررسی ارتباطات سیاسی…',
  searchingGlobalWatchlists: 'در حال جست‌وجوی فهرست‌های نظارتی…',
  agentDrivenIntelligence: 'بررسی هوشمند با عامل‌های هوش مصنوعی',
  alwaysWatching: 'پایش مستمر',
  behindTheScenesMultipleRavenAgentsOperateSimultaneouslyMonitoring:
    'عامل‌های Raven هم‌زمان شبکه‌های اجتماعی، فهرست‌های نظارتی، ریسک کشور، ارتباطات سیاسی و اخبار منفی را بررسی می‌کنند تا موارد ریسک را شناسایی و در یک گزارش یکپارچه ارائه کنند.',
  scrollToExplore: 'برای آشنایی بیشتر پیمایش کنید',
  readyToGetStartedWithRaven: 'برای شروع آماده‌اید؟',
  seeHowRavenCanStreamlineYourWorkflowBookA:
    'با امکانات Raven آشنا شوید؛ درخواست دمو بدهید یا همین حالا وارد فضای کاری شوید.',
  bookADemo: 'درخواست دمو',
  openMenu: 'باز کردن منو',
  closeMenu: 'بستن منو',
  launchRaven: 'شروع کار با Raven',
  buildAMonitoringDashboard: 'ساخت داشبورد پایش',
  buildARealTimeDashboardForYourComplianceTeam:
    'داشبوردی برای مشاهده لحظه‌ای ریسک، وضعیت مشتریان و بررسی‌های اخیر بسازید؛ با دسترسی فقط‌خواندنی و سوابق قابل حسابرسی.',
  form: 'فرم',
  buildAClientIntakeFlow: 'ساخت فرم پذیرش مشتری',
  buildFrontEndFormsThatSubmitNewClientsTo:
    'فرم ثبت مشتری را با اعتبارسنجی خودکار، مدیریت خطا و اتصال امن به API پیاده‌سازی کنید.',
  workspace: 'فضای کاری',
  buildAReviewerWorkspace: 'ساخت فضای کاری بررسی',
  aFullWorkspaceForComplianceReviewersSeeEvidenceAdd:
    'فضای کاری کارشناسان: مشاهده شواهد، ثبت یادداشت، تغییر وضعیت مشتری و نگهداری سوابق کامل.',
  launch: 'راه‌اندازی',
  launchYourDueDiligencePlatform: 'راه‌اندازی سامانه شناخت مشتری',
  theFinalEndToEndFrontEndFromSubmitting:
    'رابط کاربری کامل، از ثبت اطلاعات مشتری تا تهیه گزارش، آماده راه‌اندازی.',
  ravenApiWorkflows: 'فرایندهای مبتنی بر API',
  buildRavenWorkflowsYourself: 'فرایند دلخواه خود را بسازید',
  stepByStepGuidedWorkflowsStartWithATemplate:
    'با راهنمای گام‌به‌گام از یک نمونه اولیه به برنامه‌ای آماده استفاده برسید.',
  ourSolution: 'راهکار ما',
  whoIsRavenFor: 'Raven مناسب چه کسانی است؟',
  aboutUs: 'درباره ما',
  customerReviews: 'نظر مشتریان',
  smartDueDiligencePlatformForModernOrganizationsAutomatedIntelligent:
    'سامانه هوشمند شناخت مشتری برای سازمان‌ها؛ خودکار، دقیق و قابل پیگیری.',
  parisFrance: 'پاریس، فرانسه',
  solutions: 'راهکارها',
  quickLinks: 'دسترسی سریع',
  '2026RavenAllRightsReserved': '© ۲۰۲۶ Raven. تمامی حقوق محفوظ است.',
  smartDueDiligencePlatform: 'سامانه هوشمند شناخت مشتری',
  agenticDueDiligence: 'شناخت مشتری با هوش مصنوعی',
  automatedIntelligentTraceable: 'خودکار. هوشمند. قابل پیگیری.',
  ravenEmpowersOrganizationsTo: 'با Raven، سازمان‌ها می‌توانند',
  performKycAndKybFasterAndSmarter: 'مشتریان حقیقی و حقوقی را سریع‌تر و دقیق‌تر بررسی کنند',
  launchPlatform: 'ورود به سامانه',
  startWithApi: 'شروع با API',
  intelligentIdentityVerification: 'احراز هویت هوشمند',
  universalDocumentProcessing: 'پردازش انواع مدارک',
  automatedDataCollection: 'گردآوری خودکار اطلاعات',
  riskSignalDetectionScoring: 'شناسایی و امتیازدهی ریسک',
  complianceReportGeneration: 'تهیه گزارش تطبیق مقررات',
  continuousRiskMonitoring: 'پایش مستمر ریسک',
  knowYourIndividualClient: 'شناخت مشتری حقیقی',
  knowYourBusinessClient: 'شناخت مشتری حقوقی',
  enterpriseGradeIntelligence: 'راهکار هوشمند سازمانی',
  aUnifiedPlatformBuiltForPrecisionControlAndComplete:
    'سامانه‌ای یکپارچه برای بررسی دقیق، کنترل فرایندها و نظارت کامل بر عملیات',
  smartKycKyb: 'شناخت هوشمند مشتری حقیقی و حقوقی',
  automatedEndToEndDueDiligenceForIndividualsAnd: 'بررسی خودکار و یکپارچه اشخاص حقیقی و حقوقی',
  seeTheRiskScoringAndReportGenerationFlow: 'فرایند ارزیابی ریسک و تهیه گزارش را ببینید',
  automatedSearchAutoFillWorkflowsAndFastRiskScoring:
    'با جست‌وجوی خودکار، تکمیل اطلاعات و ارزیابی سریع ریسک، مشتریان حقیقی و حقوقی را در چند دقیقه بررسی کنید.',
  linkedin: 'LinkedIn',
  instagram: 'Instagram',
  yourComplianceReportIsReady: 'گزارش بررسی آماده است',
  profileDecision: 'مشخصات و تصمیم نهایی',
  am: 'AM',
  alexMorgan: 'الکس مورگان',
  canadian: 'کانادایی',
  netWorth: 'خالص دارایی:',
  softwareEngineer: 'مهندس نرم‌افزار',
  riskSummary: 'خلاصه ریسک',
  basedOnTheConductedKycChecksTheClientPresents:
    'بر اساس بررسی‌های انجام‌شده، ریسک مشتری متوسط تا بالا ارزیابی شده است. احتمال ارتباط با اشخاص دارای موقعیت سیاسی و چند خبر منفی درباره روابط تجاری شناسایی شده؛ شواهدی از نقش مستقیم شخص وجود ندارد. ریسک مقرراتی کشور محل فعالیت نیز متوسط است.',
  globalWatchlistMatch: 'تطبیق با فهرست نظارتی',
  pepDetected: 'ارتباط سیاسی شناسایی شد',
  adverseMediaFound: 'خبر منفی پیدا شد',
  '1HighRiskStakeholder': '۱ ذی‌نفع با ریسک بالا',
  '3MediumRiskStakeholders': '۳ ذی‌نفع با ریسک متوسط',
  relativeContributionOfEachFactorToTheClientS: 'سهم نسبی هر عامل در ریسک نهایی مشتری',
  occupationalRisk: 'ریسک شغلی',
  politicalExposure: 'ارتباطات سیاسی',
  adverseMedia: 'اخبار منفی',
  sanctionsExposure: 'ریسک تحریم',
  jurisdictionRisk: 'ریسک کشور',
  seeWhyTheBusinessHasBeenAssignedA: 'دلایل تعیین ریسک این کسب‌وکار را ببینید:',
  riskLevel: 'میزان ریسک',
  whyRiskLevelIsMedium: 'چرا ریسک متوسط است؟',
  riskIndicatorsArePresentButIndirectAndBusinessRelated:
    'نشانه‌های ریسک غیرمستقیم و مرتبط با کسب‌وکار هستند',
  noCriticalSanctionsOrAdverseMediaFindings: 'مورد جدی تحریم یا خبر منفی شناسایی نشده است',
  jurisdictionAndOccupationalRisksAreModerate: 'ریسک کشور و شغل در سطح متوسط است',
  overallExposureExceedsLowRiskThresholds: 'مجموع شواهد از آستانه ریسک پایین بیشتر است',
  detectedSignals: 'موارد شناسایی‌شده',
  riskSignals: 'موارد ریسک',
  globalWatchLists: 'فهرست‌های نظارتی جهانی',
  linkedToSanctionedCountriesOrEntities: 'ارتباط با کشورها یا نهادهای تحریم‌شده',
  '2IssuesDetected': '۲ مورد شناسایی شد',
  moreDetails: 'جزئیات بیشتر',
  pepScreening: 'بررسی اشخاص دارای موقعیت سیاسی',
  indirectRelationshipWithPoliticallyExposedPersons: 'ارتباط غیرمستقیم با اشخاص دارای موقعیت سیاسی',
  '3IssuesDetected': '۳ مورد شناسایی شد',
  noIssuesDetected: 'موردی شناسایی نشد',
  '0IssuesDetected': '۰ مورد شناسایی شد',
  onePriorRegulatoryIncident: 'یک مورد تخلف مقرراتی در گذشته',
  '1IssueDetected': '۱ مورد شناسایی شد',
  socialSignals: 'شبکه‌های اجتماعی',
  multipleRiskIndicatorsIdentifiedAcrossSocialMediaProfiles:
    'چند نشانه ریسک در حساب‌های شبکه‌های اجتماعی شناسایی شد',
  corporateAssociationVerifiedThroughLinkedinProfile:
    'ارتباط سازمانی از طریق پروفایل LinkedIn تأیید شد',
  linkedinClientAccount: 'LinkedIn (حساب مشتری)',
  frequentDisplayOfLuxuryAssetsInconsistentWithDeclaredProfile:
    'نمایش مکرر دارایی‌های لوکس، ناسازگار با اطلاعات اعلام‌شده',
  instagramClientAccount: 'Instagram (حساب مشتری)',
  repeatedInteractionWithPoliticallySensitiveContent: 'تعامل مکرر با محتوای حساس سیاسی',
  xClientAccount: 'X (حساب مشتری)',
  complianceReimaginedForHumans: 'تطبیق مقررات، با تمرکز بر نیاز انسان',
  ravenExistsToGiveComplianceTeamsTheirTimeBack:
    'Raven به تیم‌های تطبیق کمک می‌کند زمان بیشتری برای تصمیم‌گیری دقیق داشته باشند.',
  weCombine: 'ما',
  deepExpertiseWithAHumanFirstApproach: 'تخصص را با توجه به نیاز کاربران ترکیب می‌کنیم',
  toTurnComplianceFromABottleneckIntoASeamless:
    'تا رعایت مقررات به بخشی روان از کار روزمره تبدیل شود.',
  everyLayerOfOurPlatformIsBuiltTo: 'همه بخش‌های سامانه برای این هدف طراحی شده‌اند:',
  reduceFriction: 'ساده‌تر شدن کارها',
  increaseTransparency: 'شفافیت بیشتر',
  and: 'و',
  scaleWithYou: 'همراهی با رشد سازمان شما',
  withoutCompromisingOnSecurityOrPrecision: 'با حفظ امنیت و دقت',
  ourMissions: 'مأموریت ما',
  teamCollaborationOperations: 'همکاری تیمی و مدیریت عملیات',
  toolsToStreamlineTeamworkTaskManagementAndClientOversight:
    'ابزارهایی برای هماهنگی تیم، مدیریت کارها و نظارت بر مشتریان در سراسر سازمان',
  rolePermissionManagement: 'مدیریت نقش‌ها و دسترسی‌ها',
  unifiedMonitoringDashboard: 'داشبورد یکپارچه پایش',
  structuredClientDataHistory: 'اطلاعات و سوابق منظم مشتریان',
  runInstantClientScreenings: 'بررسی فوری مشتری',
  seeRiskEvidenceNeverAFakeApprovedLabel: 'مشاهده شواهد ریسک برای تصمیم‌گیری آگاهانه',
  buildASimpleSearchBoxEnterAClientName:
    'با وارد کردن نام مشتری، شواهد تحریم، ارتباطات سیاسی یا اخبار منفی را ببینید. این نتایج برای بررسی کارشناس هستند، نه تصمیم نهایی.',
  watchClientProgressLive: 'پیگیری لحظه‌ای وضعیت مشتری',
  knowExactlyWhenAScreeningFinishesOrAReport: 'از پایان بررسی و آماده شدن گزارش باخبر شوید',
  yourDashboardUpdatesInRealTimeAsWorkflowsComplete:
    'داشبورد هم‌زمان با پیشرفت کار به‌روز می‌شود. تغییر وضعیت، هشدار و خطا را بدون نیاز به تازه‌سازی مداوم ببینید.',
  shareTheRightReportWithTheRightPerson: 'اشتراک‌گذاری گزارش متناسب با مخاطب',
  customerViewVsInternalView: 'نمای مشتری و نمای داخلی',
  generateReportsTailoredToWhoSReadingClientsSee:
    'گزارش‌ها را متناسب با مخاطب ارائه کنید. مشتری فقط اطلاعات مجاز را می‌بیند و تیم بررسی به یادداشت‌ها و سوابق کامل دسترسی دارد.',
  updateClientInfoOnePieceAtATime: 'به‌روزرسانی مرحله‌ای اطلاعات مشتری',
  smallChangesSafeSavesCleanerReviews: 'تغییرات کوچک، ذخیره مطمئن، بررسی آسان‌تر',
  insteadOfSavingAnEntireProfileAtOnceUpdate:
    'فقط بخش تغییرکرده، مانند نشانی، یادداشت یا مدرک را به‌روز کنید. با ذخیره خودکار، خطا کمتر و بررسی اطلاعات ساده‌تر می‌شود.',
  createCompleteClientProfiles: 'تشکیل پرونده کامل مشتری',
  turnAScreeningIntoAPermanentClientFile: 'تبدیل نتیجه بررسی به پرونده دائمی',
  oneClickTransformsAnySearchIntoAFullClient:
    'از نتیجه جست‌وجو پرونده مشتری بسازید، یادداشت و مدرک اضافه کنید و هر زمان به سوابق منظم آن دسترسی داشته باشید.',
  keepHumanDecisionsInControl: 'تصمیم نهایی با کارشناسان شماست',
  ravenRecommendsYourTeamDecides: 'Raven پیشنهاد می‌دهد؛ تیم شما تصمیم می‌گیرد',
  buildAReviewScreenThatClearlyShowsTheEvidence:
    'در صفحه بررسی، شواهد و پیشنهاد Raven را کنار تصمیم نهایی و دلیل کارشناس ببینید. هوش مصنوعی کمک می‌کند و مسئولیت تصمیم با انسان است.',
  buildDueDiligenceYourWay: 'فرایند بررسی را متناسب با نیازتان بسازید',
  buildCustomDashboardsManageClientProfilesGenerateReportsThrough:
    'داشبورد اختصاصی بسازید، پرونده مشتریان را مدیریت کنید و با API فرایند بررسی و تهیه گزارش را خودکار کنید؛ در سامانه فعلی یا یک برنامه جدید.',
  readyToStartWithRavenApi: 'آماده استفاده از API هستید؟',
  getAccessToYourApiKeyAndAchieveWhat: 'کلید API بگیرید و پیاده‌سازی را شروع کنید',
  getYourApiKey: 'دریافت کلید API',
  riskScoreDecisionSummary: 'خلاصه ریسک و تصمیم',
  riskSignalsScreeningInsights: 'شواهد ریسک و نتایج بررسی',
  socialMediaIntelligence: 'بررسی رسانه‌ها و شبکه‌های اجتماعی',
  stakeholderRiskAnalysisKyb: 'تحلیل ریسک ذی‌نفعان (KYB)',
  advancedComplianceInsights: 'تحلیل جامع تطبیق مقررات',
  comprehensiveDecisionReadyInsightsEmbeddedInEveryGeneratedReport:
    'اطلاعات کاربردی برای تصمیم‌گیری در هر گزارش',
  riskScore: 'امتیاز ریسک',
  clearRiskClassificationLowMediumHighWithAConcise:
    'طبقه‌بندی روشن ریسک در سه سطح پایین، متوسط و بالا، همراه با خلاصه‌ای برای تصمیم‌گیری سریع‌تر',
  '': '«',
  whatOurCustomersSay: 'نظر مشتریان ما',
  realFeedbackFromPeopleWhoHaveExperiencedTheRaven: 'تجربه کسانی که از Raven استفاده کرده‌اند',
  whoIsRavenFor2: 'Raven مناسب چه کسانی است؟',
  builtForTeamsThatVerifyIdentities: 'برای تیم‌های احراز هویت و شناخت مشتری',
  forOrganizationsThatNeedReliableKycAndKyb: 'برای سازمان‌هایی که به بررسی مطمئن مشتریان نیاز دارند',
  ravenIsDesignedForOrganizationsThatNeedToVerify:
    'Raven برای سازمان‌هایی طراحی شده که مشتریان حقیقی و حقوقی را بررسی می‌کنند، به‌ویژه هنگام',
  handlingSensitiveIdentityInformation: 'کار با اطلاعات هویتی حساس',
  banksNeobanksFintechCompaniesGovernmentInstitutions:
    'بانک‌ها، نئوبانک‌ها، شرکت‌های فناوری مالی و نهادهای دولتی',
  andAnyOrganizationResponsibleForValidatingClientIdentities:
    'و هر سازمانی که مسئول تأیید هویت مشتریان است.',
  thePlatformIsBuiltSo: 'این سامانه به',
  complianceAndVerificationOfficers: 'کارشناسان تطبیق و احراز هویت',
  canReviewClientsQuicklyAndEfficientlyWhile: 'کمک می‌کند مشتریان را سریع و دقیق بررسی کنند و به',
  managersAndDecisionMakers: 'مدیران و تصمیم‌گیرندگان',
  canEasilyMonitorTheEntireProcessAndMaintainFull: 'امکان نظارت کامل بر فرایند را می‌دهد.',
  exploreSolution: 'آشنایی با راهکار',
  getInTouch: 'تماس با ما',
  readyToTransformYourComplianceOperationsReachOutTo:
    'برای آشنایی با راهکارهای Raven با تیم ما در تماس باشید.',
  fullName: 'نام و نام خانوادگی',
  johnDone: 'نام و نام خانوادگی شما',
  organizationNameOptional: 'نام سازمان (اختیاری)',
  acmeCorporation: 'نام سازمان شما',
  message: 'پیام',
  tellUsHowCanWeHelpYou: 'چطور می‌توانیم کمکتان کنیم؟',
  submit: 'ارسال',
};
